import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import SDK from "@webcollector/client-sdk";
import NodeMeJss from "@nodeme/jss-react";
import App from "./App";

SDK.init({
  apiKeys: {
    art: "EIAIZ2B8u17SPVNKILUvH7tu0raENohy9zz2WqH8",
    auth: "yXEoSjFcw88fwlKSxJMUZ4uHa557RW2A5loDbWju",
    artist: "ofvKKgYwsa8gu68IUZ4rn1agCfuz9BMSaTeTjJrs",
    customer: "4yycs9hB5O47mhqGnP67z8MOVxiN9hu24514YKTs",
    utility: "ExGOUsySRu6MrPfXwqHYQ7GRcPO0OV0c4x0Oz2Gr",
  },
  url: "webcollector.at",
  cookies: "auto",
});

NodeMeJss.init({
  palette: {
    primary: "#246cb5",
    secondary: "#2c689c",
    tertiary: "#333333",
    danger: "#b10711",
    success: "#559554",
    warning: "#e8db05",
    default: "#d9d9d9",
    body: "#ececec",
    grey: "#7d7d7d",
    black: "#3e3e3e",
    lightGrey: "#ececec",
    background: "#ececec",
    formBackground: "rgba(224, 224, 224, 0.6)",
    formBackgroundActive: "rgba(224, 224, 224, 1)",
  },
});

NodeMeJss.setDefinitions({
  link_button: {
    border: "none",
    outline: "none",
    padding: "0px",
    cursor: "pointer",
    backgroundColor: "unset",
  },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
